/**
 * News Ticker JavaScript
 * Handles smooth scrolling and performance optimizations for the news ticker
 */

class NewsTicker {
  constructor() {
    this.ticker = document.querySelector('.news-ticker-content');
    this.init();
  }

  init() {
    if (!this.ticker) return;
    
    // Ensure smooth scrolling with hardware acceleration
    this.enableHardwareAcceleration();
    
    // Handle visibility changes to pause/resume animation
    this.handleVisibilityChange();
    
    // Optimize for mobile devices
    this.optimizeForMobile();
    
    // Handle window resize
    this.handleResize();
    
    // Ensure animation starts properly
    this.ensureAnimationRuns();
  }

  enableHardwareAcceleration() {
    // Force hardware acceleration for smooth animation
    this.ticker.style.transform = 'translateZ(0)';
    this.ticker.style.willChange = 'transform';
  }

  handleVisibilityChange() {
    // Pause animation when tab is not visible to save resources
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        this.ticker.style.animationPlayState = 'paused';
      } else {
        this.ticker.style.animationPlayState = 'running';
      }
    });
  }

  optimizeForMobile() {
    // Remove mobile-specific optimization that was causing restarts on iPhone
    // Let CSS handle mobile optimization through media queries instead
    return;
  }

  handleResize() {
    // Removed resize handler that was causing ticker restarts on iPhone
    // CSS media queries will handle responsive behavior instead
    return;
  }

  ensureAnimationRuns() {
    // Don't override CSS animation - let CSS handle the animation completely
    // This prevents timing conflicts that cause restarts on iPhone
    this.ticker.style.animationPlayState = 'running';
  }
}

// Initialize news ticker - prevent duplicate instances
if (document.readyState === 'loading') {
  // If still loading, wait for DOM ready
  document.addEventListener('DOMContentLoaded', () => {
    new NewsTicker();
  });
} else {
  // If already loaded, initialize immediately
  new NewsTicker();
} 